import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "../helpers/JsonMapper";
import Background from "../Addons/Background";
import Headline from "./fieldClasses/Headline";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Block extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Block.position_attribute_name]: null,
      [Block.type_attribute_name]: null,
      [Block.visibility_locations_attribute_name]: [Block.SALE_PAGE_LOCATION],
      [Block.vertical_spaces_attribute_name]: true,
      [Block.border_visibility_attribute_name]: true,
      [Block.background_full_screen_attribute_name]: false,
      [Block.content_full_screen_attribute_name]: false,
      [Block.is_after_checkout_attribute_name]: false,
      [Block.background_attribute_name]: Background,
      [Block.headline_attribute_name]: Headline,
      [Block.background_gradient_attribute_name]: false,
      [Block.sticky_attribute_name]: false
    });
    this.setType(this.constructor.NAME);
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getPositionAttributeName() {
    return Block.position_attribute_name;
  }
  static getTypeAttributeName() {
    return Block.type_attribute_name;
  }
  static getVisibilityLocationsAttributeName() {
    return Block.visibility_locations_attribute_name;
  }
  static getVerticalSpacesAttributeName() {
    return Block.vertical_spaces_attribute_name;
  }
  static getBorderVisibilityAttributeName() {
    return Block.border_visibility_attribute_name;
  }
  static getBackgroundFullScreenAttributeName() {
    return Block.background_full_screen_attribute_name;
  }
  static getContentFullScreenAttributeName() {
    return Block.content_full_screen_attribute_name;
  }
  static getIsAfterCheckoutAttributeName() {
    return Block.is_after_checkout_attribute_name;
  }
  static getBackgroundAttributeName() {
    return Block.background_attribute_name;
  }
  static getIsBackgroundGradientAttributeName() {
    return Block.background_gradient_attribute_name;
  }
  static getStickyAttributeName() {
    return Block.sticky_attribute_name;
  }
  static getHeadlineAttributeName() {
    return Block.headline_attribute_name;
  }
  setType(type) {
    this.setAttribute(Block.getTypeAttributeName(), type);
    return this;
  }
  isAfterCheckout() {
    return this.getAttribute(Block.is_after_checkout_attribute_name);
  }
  isVisibleInSalePage() {
    return this.isVisible(Block.SALE_PAGE_LOCATION);
  }
  getType() {
    return this.getAttribute(Block.type_attribute_name);
  }
  getPosition() {
    return this.getAttribute(Block.position_attribute_name);
  }
  setPosition(position) {
    this.setAttribute(Block.position_attribute_name, position);
    return this;
  }
  isPositionedAt(position) {
    return parseInt(this.getPosition()) === parseInt(position);
  }
  getVisibilityLocations() {
    var _this$getAttribute;
    return (_this$getAttribute = this.getAttribute(Block.visibility_locations_attribute_name)) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : [];
  }
  isVisible(location) {
    let visibilityLocations = this.getVisibilityLocations();
    return Array.isArray(visibilityLocations) && visibilityLocations.includes(location);
  }
  isBackgroundFullScreen() {
    return this.getAttribute(Block.background_full_screen_attribute_name);
  }
  setBackground(background) {
    this.setAttribute(Block.getBackgroundAttributeName(), background);
    return this;
  }
  setBackgroundFullScreen(isFullScreen) {
    this.setAttribute(Block.getBackgroundAttributeName(), isFullScreen);
    return this;
  }
  makeBackgroundFullScreen() {
    this.setBackgroundFullScreen(true);
    return this;
  }
  setContentFullScreen(isContentFullScreen) {
    this.setAttribute(Block.getContentFullScreenAttributeName(), isContentFullScreen);
    return this;
  }
  makeContentFullScreen() {
    return this.setContentFullScreen(true);
  }
  setVerticalSpaces(isVisible) {
    this.setAttribute(Block.getVerticalSpacesAttributeName(), isVisible);
    return this;
  }
  removeVerticalSpaces() {
    this.setVerticalSpaces(false);
    return this;
  }
  setBorderVisibility(visibility) {
    this.setAttribute(Block.getBorderVisibilityAttributeName(), visibility);
    return this;
  }
  makeBorderInvisible() {
    this.setBorderVisibility(false);
    return this;
  }
}
_defineProperty(Block, "SALE_PAGE_LOCATION", 'main');
_defineProperty(Block, "BLOCK_TITLE", null);
_defineProperty(Block, "HOME_LOCATION", 'home');
_defineProperty(Block, "FIRST_CROSS_SELL_LOCATION", 'cross-sell-1');
_defineProperty(Block, "NAME", 'block');
_defineProperty(Block, "position_attribute_name", 'position');
_defineProperty(Block, "type_attribute_name", 'type');
_defineProperty(Block, "visibility_locations_attribute_name", 'visibility_locations');
_defineProperty(Block, "vertical_spaces_attribute_name", 'vertical_spaces');
_defineProperty(Block, "border_visibility_attribute_name", 'border_visibility');
_defineProperty(Block, "background_full_screen_attribute_name", 'background_full_screen');
_defineProperty(Block, "content_full_screen_attribute_name", 'content_full_screen');
_defineProperty(Block, "is_after_checkout_attribute_name", 'is_after_checkout');
_defineProperty(Block, "background_attribute_name", 'background');
_defineProperty(Block, "headline_attribute_name", 'headline');
_defineProperty(Block, "background_gradient_attribute_name", 'is_background_gradient');
_defineProperty(Block, "sticky_attribute_name", 'sticky');